import React, { useEffect } from 'react'
import icon from '../../assets/svg/logo-dashboard-v1.png';
import { IoClose } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';

const PushNotification = ({ notification, title, body, onClose }) => {

    const navigate = useNavigate();

    useEffect(() => {

        const timer = setTimeout(() => {
            onClose();
        }, 9000);

        return () => clearTimeout(timer);
    }, [onClose]);


    const handleNotificationClick = () => {
        if (notification?.link) {
            window.location.href = notification.link; // Redirect user to the link
        }
        onClose(); // Close the notification popup
    };

    return (
        <section className='pushnotifca'>
            <div className='notify' onClick={() => handleNotificationClick(notification)}>
                <img src={icon} alt="icon" style={{ width: "80px", height: "40px" }} />
                <div className="notify-content"  >
                    <h4 className="notify-title">{title}</h4>
                    <p className="notify-body">{body}</p>
                </div>
                <button className="notify-close" onClick={onClose}>
                    <IoClose />
                </button>
            </div>
        </section>
    )
}

export default PushNotification
